import dayjs from "dayjs";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportEntregaObraClienteTermoUseCase } from "../../../presentation/useCases/read/get_report_entrega_obra_cliente_termo_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";

/**
 * GetReportEntregaObraClienteTermoUseCase
 */

export class GetReportEntregaObraClienteTermoUseCase implements IGetReportEntregaObraClienteTermoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraClienteTermo: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportEntregaObraClienteTermo(
      requiredMimeType,
      idEntregaObraClienteTermo
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `entrega_obra_termo${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }

}
